var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent4AutoArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.08 10.46L38.3 7.1C37.76 6.42 36.94 6 36 6H12C11.06 6 10.24 6.42 9.68 7.1L6.92 10.46C6.34 11.14 6 12.04 6 13V38C6 40.2 7.8 42 10 42H38C40.2 42 42 40.2 42 38V13C42 12.04 41.66 11.14 41.08 10.46ZM24 35L13 24H20V20H28V24H35L24 35ZM10.24 10L11.86 8H35.86L37.74 10H10.24Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent4AutoArchive);
export default __webpack_public_path__ + "static/media/Component 4Auto-archive.e2f8068c18cca55dc677a226ad734734.svg";
export { ForwardRef as ReactComponent };